export default {
  root: {
    padding: '10px 20px'
  },
  label: { marginBottom: '15px' },
  dataContainer: {
    display: 'flex'
  },
  links: { cursor: 'pointer' },
  dataKey: {
    margin: '0 20px',
    width: '170px',
    flexShrink: 0
  },
  dataValue: {
    flex: 1,
    minWidth: 0,
    wordBreak: 'break-all',
    overflowWrap: 'break-word'
  }
};
